<div *ngIf="questions.length > 0">
  <div *ngIf="imageQuestion?.QuestionImageAndMedia_1 != null" class="questionImageWrapper"
    [ngClass]="{ 'question-border': !isMobile }">
    <app-question-image-and-media [questionImageAndMedias]="imageQuestion?.QuestionImageAndMedia_1"
      [imageSize]="imageQuestion?.ImageSize" [isMobile]="isMobile">
    </app-question-image-and-media>
  </div>
  <div class="fieldset-wrapper" id="Q{{ firstQuestion?.qno }}_{{ firstQuestion?.UniqueNumber }}_RW">
    <fieldset>
      <legend class="question-option-wrapper" [ngClass]="{
          'question-border': imageQuestion?.QuestionImageAndMedia_1 == null && !isMobile
        }">
        <span *ngIf="isDisplayQno" class="question-no qno-margin"><strong>{{ firstQuestion.qno }}.</strong></span>
        <span [ngClass]="{
            'question-text': matrix?.isOverAllStyleApplied,
            'question-text-nb': !matrix?.isOverAllStyleApplied,
            'no-Qno': !isDisplayQno
          }" id="lbltitle_G{{ firstQuestion?.UniqueNumber }}">
          <span *ngIf="questions[0].piping"
            [innerHTML]="getPipingTitle(questions[0]?.group_no) | headerFooterHtml"></span>
          <span *ngIf="!questions[0].piping" [innerHTML]="group?.gtitle | headerFooterHtml"></span>
          <span *ngIf="group?.QuestionTip" class="tooltip_icon" appTooltip [dataContext]="group?.QuestionTip"
            [IsButtonPanel]="false" [qid]="firstQuestion?.UniqueNumber" tabindex="0"></span>
          <div *ngIf="
              firstQuestion?.hasMedia &&
              firstQuestion?.MediaText != null &&
              firstQuestion?.MediaText != ''
            " class="question-media-text">
            <span>[{{ firstQuestion?.MediaText }}]</span>
          </div>
        </span>
      </legend>
      <div *ngIf="imageQuestion?.QuestionImageAndMedia_2 != null" class="questionImageWrapper">
        <app-question-image-and-media [questionImageAndMedias]="imageQuestion?.QuestionImageAndMedia_2"
          [imageSize]="imageQuestion?.ImageSize" [isMobile]="isMobile">
        </app-question-image-and-media>
      </div>

      <ng-container *ngIf="!isDisplayedPipeMessage; else AnswerPipeMessage">
        <div *ngIf="(isStandAlone || isMobile); else NormalGrid"
          [ngClass]="(questions[0]?.qtype =='RG' && questions[0]?.qsubtype == 1 && isMobile) ? 'mtSmileyGridMob' : ''"
          class="matrix-standalone">
          <div *ngFor="let question of questions | callBack: getHiddenQuestionsMobile; let i = index"
            [ngClass]=" i < questions.length  ? 'notLastStandAlone matrix-standalone-ques matrix-standalone-active-ques' + question.group_no : 'matrix-standalone-ques matrix-standalone-active-ques' + question.group_no">
            <!-- Radio Button -->
            <div [hidden]="question.isCQ && question.isCQHide" id="dv_g_{{ question?.UniqueNumber }}" *ngIf="
                ((question.qtype == 'SR' || question.qtype == 'GR') && question.qsubtype != 2) ||
                question.qtype == 'RG' ||
                (question.qtype == 'RW' && question.qsubtype == 1)
              " class="question-data" [ngClass]="
                isSubmitted && question.mandatory && question.AnswerText == null ? 'mandatory' : ''
              ">
              <ng-container *ngIf="
                  question.qtype == 'RG' && question.qsubtype == 1 && isMobile;
                  else RadioControl
                ">
                <app-rating-scale [JsonData]="GetQuestionsString(question)" [isDisplaySubQno]="isDisplayQno"
                  [isDisplayQno]="false" [group]="group" [isMandatoryUpfront]="question.isMandatoryStar"
                  [isMobile]="true" [isNewParticipationButton]="true" (ChangeAnswersData)="UpdateQuestionsData($event)">
                </app-rating-scale>
              </ng-container>
              <ng-template #RadioControl>
                <app-radio-button [JsonData]="GetQuestionsString(question)" [isDisplayQno]="false" [group]="group"
                  [isDisplaySubQno]="isDisplayQno" [isGrid]="isMobile ? true : false"
                  [isMandatoryUpfront]="question.isMandatoryStar" [isMobile]="false" [radiolength]="questions.length"
                  [isNewParticipationButton]="true" [isStandAlone]="isStandAlone || isMobile"
                  (ChangeAnswersData)="UpdateQuestionsData($event)">
                </app-radio-button>
              </ng-template>

              <!-- <ng-container *ngIf="isNewParticipation  && surveyFormat == 1">
          <div *ngIf="!isAutoScroll && isAnsChange" class="ques-response-btn-div">
            <input type="button" value="{{newParticipationBtnText}}" class="ques-response-btn" (click)="gotoNextQuestion(question,$event.target)"/>
          </div>
        </ng-container> -->
            </div>

            <!-- Thumbs Up  Thumbs Down -->
            <div [hidden]="question.isCQ && question.isCQHide" id="dv_g_{{ question?.UniqueNumber }}"
              *ngIf="(question.qtype == 'SR' || question.qtype == 'GR') && question.qsubtype == 2" class="question-data"
              [ngClass]="
                isSubmitted && question.mandatory && question.AnswerID == 0 ? 'mandatory' : ''
              ">
              <app-thumbs-up [JsonData]="GetQuestionsString(question)" [isDisplayQno]="false"
                [isDisplaySubQno]="isDisplayQno" [isGrid]="true" [isMandatoryUpfront]="question.isMandatoryStar"
                [isMobile]="false" (ChangeAnswersData)="UpdateQuestionsData($event)">
              </app-thumbs-up>

              <ng-container *ngIf="isNewParticipation && (surveyFormat == 1 || surveyFormat == 2)">
                <div class="ques-response-btn-div">
                  <button *ngIf="!isAutoScroll && isAnsChange" type="button" class="ques-response-btn"
                    (keyup.Space)="gotoNextQuestionKeyboard(questions, $event)"
                    (click)="gotoNextQuestion(question, $event.target)">
                    {{ newParticipationBtnText }}
                  </button>
                </div>
              </ng-container>
            </div>

            <!-- Check Box -->
            <div [hidden]="question.isCQ && question.isCQHide" id="dv_g_{{ question?.UniqueNumber }}"
              *ngIf="question.qtype == 'SC' || question.qtype == 'GC'" class="question-data" [ngClass]="
                isSubmitted && question.mandatory && question.AnswerText == null ? 'mandatory' : ''
              ">
              <app-check-box [JsonData]="GetQuestionsString(question)" [isDisplayQno]="false"
                [isDisplaySubQno]="isDisplayQno" [isGrid]="isMobile ? true : false"
                [isMandatoryUpfront]="question.isMandatoryStar" [isMobile]="false" [isNewParticipationButton]="true"
                [isStandAlone]="isStandAlone || isMobile" (ChangeAnswersData)="UpdateQuestionsData($event)">
              </app-check-box>
            </div>
          </div>
        </div>

        <ng-template #NormalGrid>
          <div class="fieldset-wrapper-scroll-cont" [style.width]="totalWidth > 100 ? '100%' : totalWidth + '%'">
            <div class="div-scroll-btn"><span class="div-scroll-symbol"></span></div>
            <div class="fieldset-wrapper-scroll">
              <div style="display: table; width: 100%" class="answerParent">
                <div class="answer-option-wrapper matrix-grid main-matrix">
                  <table cellspacing="0" cellpadding="0" role="presentation" style="min-width: 100%" [style.width]="
                      totalWidth > 100 ? (totalWidth / 100) * fullWidthPx + 'px' : '100%'
                    ">
                    <!-- Answer Option Header -->

                    <tr class="matrix-main-subq">
                      <td *ngIf="matrix?.QPos == 0" [style.width]="mainQuestionWidthString"
                        [style.min-width]="mainQuestionWidthString"></td>
                      <td>
                        <table cellspacing="0" cellpadding="0" class="sub-category-table"
                          [ngStyle]="{'table-layout': islayoutfixed ? 'fixed' : 'auto', 'word-break': islayoutfixed ? 'break-all' : 'normal'}"
                          role="presentation">
                          <tr>
                            <td *ngFor="let answer of GetAnswers(); let k = index" [hidden]="answer.isHide"
                              class="sub-category-td matrix-answer" style="text-align: center; width: 30px;"
                              [ngStyle]="{'vertical-align': GetQuestion().qtype=='RG' && GetQuestion().RSFormat==2 && !answer.isNA  ? 'top' : 'bottom'}">

                              <div *ngIf="GetQuestion().qtype=='RG' && GetQuestion().RSFormat==2"
                                class="smiley-rating mtGridSmiley {{GetQuestion().Answers.length}}">
                                <div id="scale" class="ces clear-fix RS_type_{{GetQuestion().RS_type}} RS_Format_1"
                                  style="display: table; width: 100%;"
                                  [ngClass]="{'setOf11': (isNAEnable() && GetAnswers().length - 1  == 11) ||(isNAEnable() == false && GetAnswers().length  == 11) ,
                                              'setOf10': (isNAEnable() && GetAnswers().length - 1 == 10) || (isNAEnable() == false && GetAnswers().length == 10),
                                              'setOf7': (isNAEnable() && GetAnswers().length - 1 == 7) ||(isNAEnable() == false && GetAnswers().length == 7),
                                              'setOf5': (isNAEnable() && GetAnswers().length - 1 == 5) ||(isNAEnable() == false && GetAnswers().length == 5),
                                              'setOf3': (isNAEnable() && GetAnswers().length - 1 == 3) || (isNAEnable() == false && GetAnswers().length == 3)}">
                                  <div
                                    [ngClass]="(GetQuestion().PaletteID == undefined || answer.isNA) ? '' : 'smiley smiley-'+ answer.value_id +' palette-'+GetQuestion().PaletteID+' palette'"
                                    for="NPS_{{answer.qid}}_{{answer.value_id}}">
                                    <span *ngIf="GetQuestion().PaletteID == 11" class="path1"></span>
                                    <span *ngIf="GetQuestion().PaletteID == 11" class="path2"></span>
                                  </div>
                                </div>
                              </div>
                              <ng-container *ngIf=" answer.isNA && answer.value_text == ''; else normalHeader">
                                <div id="grid_{{answer.value_id}}_SQ_Ans_Name_{{firstQuestion?.UniqueNumber}}"
                                  *ngIf="GetQuestion().qtype == 'RG'"
                                  [innerHTML]="RatingScaleHeaderText(GetQuestion(), k, answer)  | headerFooterHtml">
                                </div>
                                <div [innerHTML]="RatingScaleValueText(GetQuestion(), k, answer)   | headerFooterHtml">
                                </div>
                              </ng-container>

                              <ng-template #normalHeader>
                                <div *ngIf="GetQuestion().qtype == 'RG' "
                                  [innerHTML]="RatingScaleHeaderText(GetQuestion(), k, answer)  | headerFooterHtml">
                                </div>
                                <div id="grid_{{answer.value_id}}_SQ_Ans_Name_{{firstQuestion?.UniqueNumber}}"
                                  [innerHTML]="RatingScaleValueText(GetQuestion(), k, answer)  | headerFooterHtml">
                                </div>
                              </ng-template>
                            </td>
                          </tr>
                        </table>
                      </td>
                      <td *ngIf="matrix?.QPos != 0"></td>
                    </tr>

                    <!-- Normal Rows Start -->

                    <tr *ngFor="
                        let questionArr of questionsArray | callBack: getHiddenQuestions;
                        let i = index;
                        let odd = odd;
                        let even = even
                      " [ngClass]="{ 'odd-row': odd, 'even-row': even, 'disabled-question': isPostEditDisable(questionArr[0])}" class="controls-tr">
                      <!-- If Sub Questions at First Postion -->

                      <td *ngIf="matrix?.QPos == 0" style="width: 50px; position: relative; padding: 10px 0"
                        class="matrixTitleTd" [style.width]="mainQuestionWidthString"
                        [style.min-width]="mainQuestionWidthString" [ngClass]="{
                          matrixMandatory:
                            (questionArr[0].mandatory && isMandatoryUpfront) ||
                            (questionArr[0].mandatory &&
                              isSubmitted &&
                              questionArr[0].AnswerText == null)
                        }">
                        <span *ngIf="
                            isPreview &&
                            (questionArr[0]?.population_type == 2 ||
                              questionArr[0]?.population_type == 5)
                          " class="hidden-question-tooltip-icon" appTooltip [dataContext]="''" [IsButtonPanel]="false"
                          IsAnswerToolTip="true" IsHiddenQToolTip="true" tabindex="0">
                        </span>
                        <div class="matirx-mandatory-container" *ngIf="
                            (questionArr[0].mandatory && isMandatoryUpfront) ||
                            (questionArr[0].mandatory &&
                              isSubmitted &&
                              questionArr[0].isMandatoryInvalid)
                          ">
                          <div class="isMandatory matrix-grid-mandatory"><span class="screen-read-only">This Question is
                              Required</span></div>
                        </div>
                        <span class="qno-margin" style="display: inline-block" *ngIf="isDisplayQno">{{
                          questionArr[0]?.subQnoinChar }}</span>
                        <span *ngIf="questionArr[0].piping" [ngClass]="{ 'no-subQno-margin': !isDisplayQno }"
                          id="grid_{{ questionArr?.[0]?.UniqueNumber }}_SQ_Name"
                          [innerHTML]="questionArr[0]?.pipingQuationTitle | headerFooterHtml"></span>
                        <span *ngIf="!questionArr[0].piping" [ngClass]="{ 'no-subQno-margin': !isDisplayQno }"
                          id="grid_{{ questionArr?.[0]?.UniqueNumber }}_SQ_Name"
                          [innerHTML]="questionArr[0]?.qtitle | headerFooterHtml"></span>
                          <span class="imgPostPrepop" 
                        *ngIf="isQuestionsPostPopulated(questionArr[0])"></span>
                      </td>

                      <!-- Grid Controls -->

                      <td *ngFor="let question of questionArr; let j = index" style="height: 1px">
                        <!-- Radio Button -->
                        <table cellspacing="0" cellpadding="0" *ngIf="
                            (question.qtype == 'GR' && question.qsubtype != 2) ||
                            question.qtype == 'RG' ||
                            (question.qtype == 'RW' && question.qsubtype == 1)
                          " style="width: 100%; height: 100%; min-width: 100%; padding: 0px 2px;" role="presentation"
                          class="gridInputTable">
                          <!-- Temporary commented -->
                          <tr>
                            <td id="td_Q{{ question?.qno }}_{{ question?.UniqueNumber }}_R" [ngClass]="{
                                'matrix-border':
                                  isSubmitted &&
                                  question.mandatory &&
                                  !question.IsDisabled &&
                                  question.AnswerText == null,
                                'grid-border-inverse': matrix?.QPos != 0,
                                'grid-read-only': question.population_type == 3
                              }" style="height: 100%" class="answer-option radio gridInputTd grid-border"
                              [ngStyle]="{ display: answers.isHide ? 'none' : 'table-cell' }"
                              *ngFor="let answers of question?.Answers; let k = index">
                              <input type="radio" name="Q{{ question?.qno }}_{{ question?.UniqueNumber }}_R_NAME"
                                [attr.name]="
                                  'Q' + question?.qno + '_' + question?.UniqueNumber + '_R_NAME'
                                " [disabled]="question.IsDisabled"
                                (click)="radioButtonChangeCall(question, answers, $event)" id="lbl_Q{{ question?.qno }}_{{ question?.UniqueNumber }}_R_{{
                                  answers?.value_id
                                }}_ID" value="{{ answers.value_text }}" [(ngModel)]="answers.ControlAns"
                                [attr.aria-labelledby]="
                                  'grid_' +
                                  answers.value_id +
                                  '_SQ_Ans_Name_' +
                                  firstQuestion?.UniqueNumber +
                                  ' ' +
                                  'grid_' +
                                  question.UniqueNumber +
                                  '_SQ_Name'
                                " [attr.aria-required]="
                                  (questionArr[0].mandatory && isMandatoryUpfront) ||
                                  (questionArr[0].mandatory &&
                                    isSubmitted &&
                                    questionArr[0].isMandatoryInvalid)
                                " (change)="nextQuestion($event.target)" />

                              <label for="lbl_Q{{ question?.qno }}_{{ question?.UniqueNumber }}_R_{{
                                  answers?.value_id
                                }}_ID" style="height: 100%; justify-content: center"
                                [attr.aria-label]="'Answer: ' + answers?.display_text">
                                <span class="radio-btn structure"></span>
                                <span style="
                                  position: absolute; 
                                  width: 1px; 
                                  height: 1px; 
                                  padding: 0; 
                                  margin: -1px; 
                                  overflow: hidden; 
                                  clip: rect(0, 0, 0, 0); 
                                  white-space: nowrap; 
                                  border: 0;
                                ">
                                  Select answer {{ answers?.value_id }}
                                </span>
                              </label>
                            </td>
                          </tr>
                          <!-- Temporary commented -->
                        </table>

                        <!-- Thumbs Up / Thumbs Down -->
                        <table cellspacing="0" cellpadding="0" *ngIf="question.qtype == 'GR' && question.qsubtype == 2"
                          style="width: 100%; height: 100%; min-width: 100%; padding: 0px 2px;" role="presentation"
                          class="gridInputTable">
                          <tr>
                            <td id="td_Q{{ question?.qno }}_{{ question?.UniqueNumber }}_R" [ngClass]="
                                isSubmitted &&
                                question.mandatory &&
                                !question.IsDisabled &&
                                question.AnswerText == null
                                  ? 'matrix-border'
                                  : ''
                              " style="height: 100%; vertical-align: middle"
                              class="answer-option radio gridInputTd grid-border"
                              [ngStyle]="{ display: answers.isHide ? 'none' : 'table-cell' }"
                              *ngFor="let answers of question?.Answers; let k = index">
                              <div class="ld-box">
                                <input type="radio" [disabled]="answers?.isQuotaDisable"
                                  (click)="radioButtonChangeCall(question, answers, $event)"
                                  name="Q{{ question?.qno }}_{{ question?.UniqueNumber }}_R_NAME" [attr.name]="
                                    'Q' + question?.qno + '_' + question?.UniqueNumber + '_R_NAME'
                                  " id="lbl_Q{{ question?.qno }}_{{ question?.UniqueNumber }}_R_{{
                                    answers?.value_id
                                  }}_ID" value="{{ answers.value_text }}" [(ngModel)]="answers.ControlAns"
                                  [attr.aria-labelledby]="
                                    'grid_' +
                                    answers.value_id +
                                    '_SQ_Ans_Name_' +
                                    firstQuestion?.UniqueNumber +
                                    ' ' +
                                    'grid_' +
                                    question.UniqueNumber +
                                    '_SQ_Name'
                                  " />

                                <label for="lbl_Q{{ question?.qno }}_{{ question?.UniqueNumber }}_R_{{
                                    answers?.value_id
                                  }}_ID" [ngClass]="
                                    answers?.value_id == 1
                                      ? 'ld-common like-box'
                                      : answers?.value_id == 2
                                        ? 'ld-common dislike-box'
                                        : ''
                                  "></label>
                              </div>
                            </td>
                          </tr>
                        </table>

                        <!-- Check Box-->

                        <table cellspacing="0" cellpadding="0" *ngIf="question.qtype == 'GC'"
                          style="width: 100%; height: 100%; padding: 0px 2px;" role="presentation">
                          <tr>
                            <td class="answer-option check grid-border" [ngClass]="{
                                'matrix-border':
                                  isSubmitted &&
                                  question.mandatory &&
                                  !question.IsDisabled &&
                                  question.AnswerText == null,
                                'grid-read-only': question.population_type == 3
                              }" *ngFor="let answers of question?.Answers; let k = index"
                              [ngStyle]="{ display: answers.isHide ? 'none' : 'table-cell' }">
                              <input type="checkbox" name="Q{{ question?.qno }}_{{ question?.UniqueNumber }}_C_NAME"
                                [attr.name]="
                                  'Q' + question?.qno + '_' + question?.UniqueNumber + '_C_NAME'
                                " [disabled]="question.IsDisabled" id="lbl_Q{{ question?.qno }}_{{ question?.UniqueNumber }}_C_{{
                                  answers?.value_id
                                }}_ID" value="{{ answers.value_text }}" [(ngModel)]="answers.ControlAns" (change)="
                                  CheckBoxSelectedValue(answers, $event.target.checked, question)
                                " [disabled]="answers?.isQuotaDisable" [attr.aria-labelledby]="
                                  'grid_' +
                                  answers.value_id +
                                  '_SQ_Ans_Name_' +
                                  firstQuestion?.UniqueNumber +
                                  ' ' +
                                  'grid_' +
                                  question.UniqueNumber +
                                  '_SQ_Name'
                                " [attr.aria-required]="
                                  (questionArr[0].mandatory && isMandatoryUpfront) ||
                                  (questionArr[0].mandatory &&
                                    isSubmitted &&
                                    questionArr[0].isMandatoryInvalid)
                                " />
                              <label for="lbl_Q{{ question?.qno }}_{{ question?.UniqueNumber }}_C_{{
                                  answers?.value_id
                                }}_ID" [ngClass]="answers.ControlAns ? 'selectedAnsOpt' : ''"
                                style="height: 100%; justify-content: center"
                                [attr.aria-label]="'Answer: ' + answers?.display_text">
                                <span class="check-btn structure"></span>
                                <span style="
                                  position: absolute; 
                                  width: 1px; 
                                  height: 1px; 
                                  padding: 0; 
                                  margin: -1px; 
                                  overflow: hidden; 
                                  clip: rect(0, 0, 0, 0); 
                                  white-space: nowrap; 
                                  border: 0;
                                ">
                                  Select answer {{ answers?.value_id }}
                                </span>
                              </label>
                            </td>
                          </tr>
                        </table>
                      </td>

                      <!-- If Sub Questions at Last Postion -->

                      <td *ngIf="matrix?.QPos != 0" style="width: 50px; position: relative; padding: 10px 0"
                        class="matrixTitleTd" [style.width]="mainQuestionWidthString" [ngClass]="{
                          matrixMandatory:
                            (questionArr[0].mandatory && isMandatoryUpfront) ||
                            (questionArr[0].mandatory &&
                              isSubmitted &&
                              questionArr[0].AnswerText == null)
                        }">
                        <div class="matirx-mandatory-container" *ngIf="
                            (questionArr[0].mandatory && isMandatoryUpfront) ||
                            (questionArr[0].mandatory &&
                              isSubmitted &&
                              questionArr[0].AnswerText == null)
                          ">
                          <div class="isMandatory matrix-grid-mandatory"><span class="screen-read-only">This Question is
                              Required</span></div>
                        </div>
                        <span class="qno-margin" style="display: inline-block" *ngIf="isDisplayQno">{{
                          questionArr[0]?.subQnoinChar }}</span>
                        <span *ngIf="questionArr[0].piping" [ngClass]="{ 'no-subQno-margin': !isDisplayQno }"
                          id="grid_{{ questionArr[0].UniqueNumber }}_SQ_Name"
                          [innerHTML]="questionArr[0]?.pipingQuationTitle | headerFooterHtml"></span>
                        <span *ngIf="!questionArr[0].piping" [ngClass]="{ 'no-subQno-margin': !isDisplayQno }"
                          id="grid_{{ questionArr[0].UniqueNumber }}_SQ_Name"
                          [innerHTML]="questionArr[0]?.qtitle | headerFooterHtml"></span>
                      </td>
                      <div *ngIf="isNgOnChange && ngCount == 1 && i == questionsArray.length - 1">
                        {{ ngAfterHandle() }}
                      </div>
                    </tr>
                  </table>
                  <ng-container *ngIf="isNewParticipation && (surveyFormat == 1 || surveyFormat == 2)">
                    <div class="ques-response-btn-div">
                      <button *ngIf="showNewParticipationButton && isAnsChange" type="button" class="ques-response-btn"
                        (keyup.Space)="gotoNextQuestionKeyboard(questions, $event)"
                        (click)="gotoNextQuestion(questions[0], $event.target)">
                        {{ newParticipationBtnText }}
                      </button>
                    </div>
                  </ng-container>
                </div>
              </div>
            </div>
          </div>
        </ng-template>
      </ng-container>

      <ng-template #AnswerPipeMessage>
        <span [innerHTML]="getAnswerPipeMessage() | headerFooterHtml" class="hidden-message"></span>
      </ng-template>
    </fieldset>
  </div>
</div>